import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { emptyMatchIncidents, MatchIncidents } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MatchIncidentsService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingMatchIncidents = signal<boolean>(false);
  isErrorMatchIncidents = signal<boolean>(false);
  matchIncidents = signal<MatchIncidents>(emptyMatchIncidents);

  getMatchIncidents(matchId: String) {
    this.isLoadingMatchIncidents.set(true);
    this.isErrorMatchIncidents.set(false);

    this.http
      .get<MatchIncidents>(
        `${this.env.baseUrlWeb}/matches/${matchId}/incidents`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingMatchIncidents.set(false);
          this.isErrorMatchIncidents.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.matchIncidents.set(emptyMatchIncidents);
          return;
        }

        this.matchIncidents.set(data);
        this.isLoadingMatchIncidents.set(false);
      });
  }

  refreshMatchIncidents(matchId: string) {
    this.http
      .get<MatchIncidents>(
        `${this.env.baseUrlWeb}/matches/${matchId}/incidents`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError(() => {
          this.isErrorMatchIncidents.set(true);
          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) return;

        this.matchIncidents.set(data);
      });
  }
}
